<template>
      <div id="sydney-health">
            <section class="sydney-hero-photo animate__animated animate__fadeIn">
                  <img src="~@/assets/img/sydney-health-hero-2026.jpg" alt="Woman looking at her phone on a train" />
                  <BackButton link="/resources" />
                  <div class="sydney-hero-title">
                        <h1>Sydney<sup>SM</sup><br />Health</h1>
                  </div>
            </section>
            <section class="sydney-content">
                  <div class="grid-container max">
                        <p class="sydney-lead">Sydney<sup>SM</sup> Health is an intuitive, digital mobile platform that directly connects you to your benefit information on the go &mdash; 24/7.</p>
                        <div class="sydney-grid">
                              <div class="sydney-left">
                                    <ul>
                                          <li>See what&rsquo;s covered by your plan</li>
                                          <li>Get an estimate on service costs</li>
                                          <li>Find in-network doctors/specialists near you</li>
                                          <li>Access your digital ID card</li>
                                          <li>Access virtual care</li>
                                          <li>Get answers quickly with interactive chat</li>
                                          <li>Check the status of an authorization</li>
                                    </ul>
                                    <p class="sydney-login"><a href="https://www.anthem.com/login/" target="_blank" @click="track('Link', 'Log-in - Sydney Health')">Log-in</a> with your Anthem username and password. If you aren&rsquo;t registered online, <a href="https://www.anthem.com/login/" target="_blank" @click="track('Link', 'Create Account - Sydney Health')">create an account</a> today.</p>
                              </div>
                              <div class="sydney-right">
                                    <div class="sydney-download">
                                          <p>Download the Sydney<sup>SM</sup> Health app today from the App Store or Google Play.</p>
                                          <div class="sydney-badges">
                                                <a href="https://play.google.com/store/apps/details?id=com.anthem.sydney&hl=en_US&gl=US" target="_blank" @click="track('CTA', 'Google Play - Sydney Health')"><img src="~@/assets/img/google-play.png" alt="Get it on Google Play" /></a>
                                                <a href="https://apps.apple.com/us/app/sydney-health/id1463423283" target="_blank" @click="track('CTA', 'Apple App Store - Sydney Health')"><img src="~@/assets/img/app-store.png" alt="Download on the App Store" /></a>
                                          </div>
                                    </div>
                                    <div class="sydney-phone">
                                          <img src="~@/assets/img/sydney-iphone.png" alt="Sydney Health app on a phone" />
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
            <div class="sydney-btn-wrap">
                  <router-link to="/livehealth-online" class="sydney-btn"><span>Next</span></router-link>
            </div>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPSydneyHealth",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#sydney-health {
      .sydney-hero-photo {
            position: relative;
            margin-top: 68px;
            height: 560px;
            overflow: hidden;

            img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
            }

            .back-btn {
                  position: absolute;
                  top: 40px;
                  left: 86px;
                  border-color: #ffffff;

                  &::before {
                        background-image: none;
                        background-color: #ffffff;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .sydney-hero-title {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  text-align: left;
                  padding: 0 24px 0 86px;

                  h1 {
                        color: #ffffff;
                        font-size: clamp(2.75rem, 5vw, 4.5rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;

                        sup {
                              font-size: 0.4em;
                        }
                  }
            }
      }

      .sydney-content {
            background-color: #ffffff;
            padding: 64px 0 160px 0;

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .sydney-lead {
                  color: #012E58;
                  font-size: 1.25rem;
                  font-weight: 600;
                  line-height: 1.4;
                  max-width: 760px;
                  margin-bottom: 32px;
            }

            .sydney-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 48px;
            }

            .sydney-left {
                  flex: 1 1 420px;
                  max-width: 600px;

                  ul {
                        margin: 0 0 24px 1.125rem;
                        padding: 0;

                        li {
                              color: #3F3A4E;
                              font-size: 1rem;
                              line-height: 1.6;
                              margin-bottom: 8px;

                              &:last-child {
                                    margin-bottom: 0;
                              }
                        }
                  }

                  .sydney-login {
                        color: #12130f;
                        font-size: 1rem;
                        line-height: 1.6;
                        margin: 24px 0 0 0;

                        a {
                              color: #1355E9;
                              font-weight: 700;
                              text-decoration: underline;
                        }
                  }
            }

            .sydney-right {
                  flex: 1 1 420px;
                  max-width: 560px;
                  display: flex;
                  align-items: flex-end;
                  justify-content: flex-end;
                  gap: 24px;

                  .sydney-download {
                        flex: 0 1 260px;

                        p {
                              color: #12130f;
                              font-size: 1rem;
                              line-height: 1.5;
                              margin-bottom: 16px;
                        }
                  }

                  .sydney-badges {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 12px;

                        img {
                              display: block;
                              height: 44px;
                              width: auto;
                        }
                  }

                  .sydney-phone {
                        flex: 0 0 auto;

                        img {
                              display: block;
                              width: 220px;
                              height: auto;
                        }
                  }
            }
      }

      .sydney-btn-wrap {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 3;
            background-color: #ffffff;
            box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
            padding: 20px 0;
            text-align: center;
      }

      .sydney-btn {
            display: block;
            background-color: #1355E9;
            color: #ffffff !important;
            font-weight: 700;
            text-transform: uppercase;
            font-size: 1rem;
            padding: 18px 0;
            width: 100%;
            max-width: 330px;
            text-align: center;
            border-radius: 30px;
            border: none;
            cursor: pointer;
            margin: 0 auto;

            &:hover {
                  background-color: #44B8F3;
            }
      }

      @media only screen and (max-width: 959px) {
            .sydney-hero-photo {
                  height: 380px;

                  .back-btn {
                        top: 24px;
                        left: 2rem;
                  }

                  .sydney-hero-title {
                        padding: 0 24px 0 24px;

                        h1 {
                              font-size: clamp(2.25rem, 9vw, 3.25rem) !important;
                        }
                  }
            }

            .sydney-content {
                  padding: 40px 24px 180px 24px;

                  .sydney-grid {
                        flex-direction: column;
                        gap: 40px;
                  }

                  .sydney-left {
                        flex: 0 0 auto;
                        max-width: 100%;
                  }

                  .sydney-right {
                        flex: 0 0 auto;
                        max-width: 100%;
                        width: 100%;
                        justify-content: flex-start;
                        align-items: flex-start;
                        flex-direction: column-reverse;
                        gap: 32px;

                        .sydney-phone img {
                              width: 180px;
                        }
                  }
            }
      }
}
</style>
